import React from 'react';
import PropTypes from 'prop-types';
import { StyledPaper } from './styled';

const Paper = ({ children, inline, backgroundColor, noShadow, customStyle }) => {
  return (
    <StyledPaper
      inline={inline}
      backgroundColor={backgroundColor}
      noShadow={noShadow}
      customStyle={customStyle}
    >
      {children}
    </StyledPaper>
  );
};

Paper.propTypes = {
  children: PropTypes.node,
  inline: PropTypes.bool,
  backgroundColor: PropTypes.string,
  noShadow: PropTypes.bool,
  customStyle: PropTypes.array
};

Paper.defaultProps = {
  inline: false,
  noShadow: false
};

export default React.memo(Paper);
